export default "__VITE_ASSET__DRWw6GmZ__"